import "./SearchBar.css";

import {useDashboardLocale} from "../../context/dashboard_locale";
import {useState, useEffect} from "react";

import {capitalize} from "../../utils/strings";

export default function SearchBar(props) {
  const placeholder = props.placeholder;
  const onSearch = props.onSearch;
  const value = props.children || "";
  const [text, setText] = useState(value);
  const {strings} = useDashboardLocale();
  useEffect(() => {
    setText(value);
  }, [props]);

  function onSearchClick() {
    onSearch(text);
  }

  return (
    <div className="relative">
      <div className="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
        <svg className="w-4 h-4 text-black" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
          <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"/>
        </svg>
      </div>
      <input 
        type="search" 
        className="block w-full p-4 ps-10 text-base text-black rounded-lg bg-gray-200 focus:ring-primary-500" 
        placeholder={placeholder}
        onChange={(e) => setText(e.target.value)}
        value={text}
      />
      <button 
        className="text-white absolute end-2.5 bottom-2.5 bg-primary-500 hover:bg-primary-700 font-medium rounded-lg text-base px-4 py-2"
        onClick={onSearchClick}
      >
        {capitalize(strings["search"])}
      </button>
    </div>
  );
}